module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px"
    },
    attrs: {
      "id": "content-wrap"
    }
  }, [(_vm.isChecking) ? _c('div', [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Please wait!!")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : (_vm.isVerified) ? _c('div', [_c('h1', [_vm._v("Thank You!")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("Your Email Address is now verified!!")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("To login click here: "), _c('b', {
    staticStyle: {
      "color": "#367fa9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Login')
      }
    }
  }, [_vm._v("Login")])])])]) : _c('div', [_c('h1', [_vm._v("Sorry!!")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Your Email Address verification is failed!!")]), _vm._v(" "), (_vm.error) ? _c('div', [_c('h4', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.isResend) ? _c('h4', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.resendVerification()
      }
    }
  }, [_vm._v("Re-Send Verification email")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.$root.isLoading
    },
    on: {
      "update:active": function($event) {
        return _vm.$set(_vm.$root, "isLoading", $event)
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', [_vm._v("Verifing you Email Address ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("We sent you an email \"How To\" use "), _c('b', {
    staticStyle: {
      "color": "#367fa9"
    }
  }, [_vm._v("Printer Counters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', [_vm._v("(Please check you email inbox)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bef068e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Verify.vue
// module id = 711
// module chunks = 0